export default __webpack_public_path__ + "static/logo-39721c8d2ab2eb1926643d5b129dda13.svg";